import { Component, AfterViewInit, Renderer2, Inject, OnInit } from '@angular/core';
import { AuthenticationService, CompanyService, AlertService,ProfileService } from '../../_services/index';
import { environment } from '../../../environments/environment';
import { FormGroup, FormControl,Validators } from '@angular/forms';
import * as Prism from 'prismjs';
import {Router, ActivatedRoute} from "@angular/router"
import { DOCUMENT } from '@angular/platform-browser';
import { ThemeService } from 'ng2-charts';
@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit {
    public authorized:any;
    public company:any;
    public param:any;
    public users:any;
    public a:any;
    constructor(
        public as: AuthenticationService,
        public alertService:AlertService,
        public companyService: CompanyService,
        public profileService: ProfileService,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(DOCUMENT) private _document,
    ){
        this.authorized = this.as.checkAuthentication();
        if(!this.authorized.authorized){
            this.router.navigate(['/login'])
        }
    }

    ngOnInit() {
        if (this.route.snapshot.params && this.route.snapshot.params.id) {
            this.getCompany(this.route.snapshot.params.id)
        }else{
            this.company = {}
            this.company.roleId='';
        }
    }
    getCompany(data){
        this.companyService.getCompany(data).subscribe(response => {
            this.company = response;
            if(!response){
                this.alert({reason:'No se ha cargado la empresa.', type:"danger"});
                this.router.navigate(['/empresas']);
            }
        }, error => {
            this.alert({reason:'No se ha cargado la empresa.', type:"danger"});
            this.router.navigate(['/empresas']);
        })
    }
    delete(){
        this.companyService.deleteCompany(this.company).subscribe(response => {
            this.alert({reason:'La empresa ha sido eliminada con éxito.', type:"success"});
            this.router.navigate(['/empresas']);
        }, error => {
            this.alert({reason:'La empresa no ha sido eliminada, intentalo nuevamente.', type:"danger"});
        })
    }
    getSave(){
        if(this.route.snapshot.params.id){
            this.companyService.updateCompany(this.company).subscribe(response => {
                this.alert({reason:'La empresa ha sido actualizada con éxito.', type:"success"});
                this.router.navigate(['/empresas']);
            }, error => {
                this.alert({reason:'La empresa no ha sido actualizada, intentalo nuevamente.', type:"danger"});
            })
        }else{
            this.companyService.newCompany(this.company).subscribe(response => {
                this.alert({reason:'La empresa ha sido creada con éxito.', type:"success"});
                this.router.navigate(['/empresas']);
            }, error => {
                this.alert({reason:'La empresa no ha sido creada, intentalo nuevamente.', type:"danger"});
            })
        }
    }
    url(path){
        this.router.navigate([path]);
      }
    alert(data){
        this.alertService.updateAlert(data).subscribe(()=>{
            setTimeout(() => {
            this.alertService.deleteAlert().subscribe();
            }, 8000);
        })
    }
    
}

